import { useEffect } from 'react';
import { useAuth0User } from './useAuth0User';
import useEnableUserQuickSwitcher from './useEnableUserQuickSwitcher';
import useRememberLoginOrganisation from './useRememberLoginOrganisation';
import { clearLastUsedOrgId } from './useLastUsedOrgId';
import { clearLastUsedUserEmail } from './useLastUsedUserEmail';
import { getLastAuthenticatedOrgId, setLastAuthenticatedOrgId } from './useLastAuthenticatedOrgId';

// the quick switcher and "remember login org" settings assume a workstation is used for a
//  single org - if this browser authenticates into a different org, any previous org's
//  browser-level preferences and cached data are stale and would otherwise leak into the new org
export const useClearStaleWorkstationCacheOnOrgSwitch = (): void => {
  const auth0User = useAuth0User();
  const [, setQuickSwitcherOnThisBrowser] = useEnableUserQuickSwitcher();
  const [, setRememberLoginOrgOnThisBrowser] = useRememberLoginOrganisation();

  useEffect(() => {
    if (!auth0User.isAuthenticated || !auth0User.org_id) return;

    const previousOrgId = getLastAuthenticatedOrgId();
    if (previousOrgId && previousOrgId !== auth0User.org_id) {
      setQuickSwitcherOnThisBrowser(false);
      setRememberLoginOrgOnThisBrowser(false);
      clearLastUsedUserEmail();
      clearLastUsedOrgId();
    }

    setLastAuthenticatedOrgId(auth0User.org_id);
  }, [auth0User, setQuickSwitcherOnThisBrowser, setRememberLoginOrgOnThisBrowser]);
};

export default useClearStaleWorkstationCacheOnOrgSwitch;
